import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

/**
 * @author Abdulqodir
 * @dateCreated 23 Aug 2024
 * @description A pipe that format timestamps to relative format
 */

@Pipe({
  name: 'relativeTime',
  pure: false,
})
export class TimeStampToRelativeFormat implements PipeTransform {
  transform(value: any, ...args: any[]) {
    return moment(value).fromNow();
  }
}
